import moment from 'moment'

export const Patient = {
    id: '',
    name: '',
    qq: '',
    gender: null,
    dateOfBirth: null,
    placeOfBirth: '',
    religion: '',
    address: '',
    allergy: '',
    occupation: '',
    treatmentId: '',
    treatmentName: '',
    treatmentOther: '',
    provinceId: '',
    regenciesId: '',
    districtId: '',
    villageId: '',
    reference: '',
    cellPhone: '',
    height: '',
    weight: '',
    bloodPressure: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}

export const PatientDiseaseHistory = {
    id: '',
    patientId: '',
    name: '',
    remarks: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}

export const PatientMedicationHistory = {
    id: '',
    patientId: '',
    name: '',
    remarks: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}